import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from '@eluve/components';

const factVerifcationPaths = [
  { name: 'Workflows', path: '' },
  { name: 'Source Artifacts', path: 'artifacts' },
  { name: 'Datasets', path: 'datasets' },
  { name: 'Create Workflow', path: 'workflow/create' },
];

const ActiveLocationBreadcrumb = () => {
  const location = useLocation();

  let currentPathName = 'Workflows';

  factVerifcationPaths.forEach((p) => {
    if (p.path.length) {
      if (location.pathname.includes(p.path)) {
        currentPathName = p.name;
      }
    }
  });

  return (
    <BreadcrumbItem>
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-1">
          {currentPathName}
          <Icon name="ChevronDown" size="lg" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          {factVerifcationPaths.map((location) => (
            <DropdownMenuItem key={location.name} asChild>
              <NavLink to={`fact-verification/${location.path}`}>
                {location.name}
              </NavLink>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </BreadcrumbItem>
  );
};

export const FactVerifactionBreadcrumbs: React.FC = () => {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/admin/fact-verification">Fact Verification</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <ActiveLocationBreadcrumb />
      </BreadcrumbList>
    </Breadcrumb>
  );
};
